import { render, staticRenderFns } from "./PagedInfos.vue?vue&type=template&id=5e28f477&"
import script from "./PagedInfos.vue?vue&type=script&lang=js&"
export * from "./PagedInfos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports